export const COMPLETE_IMAGE_UPLOAD = 'COMPLETE_IMAGE_UPLOAD'
export const FAILED_CREATE_IMAGE = 'FAILED_CREATE_IMAGE'
export const FAILED_IMAGE_UPLOAD = 'FAILED_IMAGE_UPLOAD'
export const RECEIVE_CREATE_IMAGE = 'RECEIVE_CREATE_IMAGE'
export const RECEIVE_IMAGE_UPLOAD = 'RECEIVE_IMAGE_UPLOAD'
export const REQUEST_CREATE_IMAGE = 'REQUEST_CREATE_IMAGE'
export const REQUEST_IMAGE_UPLOAD = 'REQUEST_IMAGE_UPLOAD'
export const RESET_IMAGE_UPLOAD = 'RESET_IMAGE_UPLOAD'
